module.exports = __webpack_public_path__ + "img/16.b741f1aa.jpg";